export const StorageKeys = {
  pendingRegistration: "apaato.pending_registration",
  dashboardWelcomeShown: "apaato.dashboard_welcome_shown",
} as const;
